import * as React from 'react'
// import * as Assets from '../../../Assets/Assets'
import {Main} from '../../../Logic/Main'
import {Logic} from '../../../Logic/Type'
import * as Init from './Init'
import * as RewardShop from './RewardShop'

function RunOnce() {
    if (Main.Instance.IndexState.runOnce) {
        getLevels()
        Logic.Type.New(Main.Instance.IndexState, {runOnce: false})
        Init.Init()
    }
}

// function HideGame() {Rest.getWallet()}
/*
export function Home(getData: boolean) {

    HideGame()

    if (getData) {
        Init.Init()
        // Games.UglyLoadGames()
    }

    Logic.Type.New(Main.Instance.LoginState, {
        Mode: false,
        AccountJustCreated: Assets.NULL,
        PlayerExists: false,
        GameMode: false,
        IframeLink: undefined
    })
}
*/
export function getLevels() {
    let levels_altogether: number = 0
    let levels: string[] = []
    let currentLevel: number = -1
    let currentSubLevel: number = -1
    let currentLevelName: string = ''
    let sublevels: number[] = []

    if (Main.Instance.IndexState.Levels) {
        for (let i: number = 0; i < Main.Instance.IndexState.Levels.length; i++) {
            if (parseInt(Main.Instance.IndexState.Levels[i]['sublevels']) > 0) {
                levels.push(Main.Instance.IndexState.Levels[i]['name'])
                levels_altogether += parseInt(Main.Instance.IndexState.Levels[i]['sublevels'])
                if (Main.Instance.LoginState.Verified && Main.Instance.IndexState.PointsXPL !== undefined) {
                    if (Main.Instance.IndexState.PointsXPL >= parseInt(Main.Instance.IndexState.Levels[i]['prte'])) {
                        currentLevel = i
                        currentLevelName = Main.Instance.IndexState.Levels[i]['name']
                    }
                }
            } else if (Main.Instance.IndexState.Levels[i]['final_level'] === true) {
                if (!Main.Instance.IndexState.finalLevelName) {
                    Logic.Type.New(Main.Instance.IndexState,{finalLevelName:Main.Instance.IndexState.Levels[i]['name']})
                }
                levels_altogether += 1
                levels.push(Main.Instance.IndexState.Levels[i]['name'])
                if (Main.Instance.LoginState.Verified && Main.Instance.IndexState.PointsXPL !== undefined) {
                    if (Main.Instance.IndexState.PointsXPL >= parseInt(Main.Instance.IndexState.Levels[i]['prte'])) {
                        currentLevel = i
                        currentLevelName = Main.Instance.IndexState.Levels[i]['name']
                    }
                }
            }
        }
/* THIS IS COMMENTED OUT AS THERE ARE NOT DYNAMIC LEVELS ANYMORE
        if (currentLevel > - 1 && parseInt(Main.Instance.IndexState.Levels[currentLevel]['sublevels']) > 0) {
            let XPLR: number = parseInt(Main.Instance.IndexState.Levels[currentLevel]['prte'])
            let XPLRP: number
            let subLevels: number = parseInt(Main.Instance.IndexState.Levels[currentLevel]['sublevels'])
            let Stagnation: number = parseInt(Main.Instance.IndexState.Levels[currentLevel]['stagnation'])
            let levelValue: number = parseInt(Main.Instance.IndexState.Levels[currentLevel]['level_value'])
            let stagnation: number = 1000
            let DIFF: number = 1 / stagnation

            for (let i: number = 0; i < subLevels; i++) {
                sublevels.push(0)
            }

            let sublevels_even: boolean = subLevels % 2 === 0 ? true : false

            if (sublevels_even === true) {
                for (let i: number = 0; i < subLevels; i++) {
                    let diff: number = i - subLevels / 2
                    let stagDiff: number = Stagnation - stagnation

                    if (i >= subLevels / 2) {
                        sublevels[i] = levelValue + diff * DIFF * stagDiff
                    } else {
                        sublevels[i] = levelValue + (diff + 1) * DIFF * stagDiff
                    }
                }
            } else {
                for (let i: number = 0; i < subLevels; i++) {
                    let diff: number = i - (subLevels - 1) / 2
                    let stagDiff: number = Stagnation - stagnation

                    if (i > (subLevels - 1) / 2) {
                        sublevels[i] = levelValue + (diff - 1) * DIFF * stagDiff
                        let Diff = Stagnation - (stagnation + 1)
                        if (i === (subLevels - 1) / 2) {
                            sublevels[i] += Diff * DIFF
                        } else sublevels[i] -= DIFF

                        sublevels[i] -= - DIFF * 2 - Diff / stagnation

                    } else {
                        sublevels[i] = levelValue + (diff) * DIFF * stagDiff
                    }
                }
            }
            currentSubLevel = 1
            for (let i: number = 0; i < sublevels.length; i++) {
                XPLRP = XPLR
                XPLR += sublevels[i]
                if (Main.Instance.IndexState.PointsXPL >= XPLR) {
                    currentSubLevel = i + 2
                } else break
            }

            let start: number = parseInt(Main.Instance.IndexState.Levels[currentLevel]['prte'])
            let destination: number = levelValue * subLevels
            let Progress = (Main.Instance.IndexState.PointsXPL - start) / destination * 100
            if (Progress !== Main.Instance.IndexState.progress) {
                Logic.Type.New(Main.Instance.IndexState, { progress: Progress })
            }
            if (XPLR !== Main.Instance.IndexState.PointsXPLR) {
                Logic.Type.New(Main.Instance.IndexState, { PointsXPLR: XPLR })
            }
            if (XPLRP !== Main.Instance.IndexState.PointsXPLRP) {
                Logic.Type.New(Main.Instance.IndexState, { PointsXPLRP: XPLRP })
            }
        }
*/
    }

    if (levels_altogether !== Main.Instance.IndexState.levels_altogether) {
        Logic.Type.New(Main.Instance.IndexState, { levels_altogether: levels_altogether })
    }

    if (!Main.Instance.IndexState.levels || Main.Instance.IndexState.levels.length !== levels.length) {
        Logic.Type.New(Main.Instance.IndexState, { levels: levels })
    }

    if (currentLevel !== Main.Instance.IndexState.currentLevel) {
        Logic.Type.New(Main.Instance.IndexState, {
            currentLevel: currentLevel,
            sublevels: sublevels,
            subLevels: sublevels.length
        })
    }

    if (currentSubLevel !== Main.Instance.IndexState.currentSubLevel) {
        Logic.Type.New(Main.Instance.IndexState, { currentSubLevel: currentSubLevel })
    }

    if (currentLevelName !== Main.Instance.IndexState.currentLevelName) {
        Logic.Type.New(Main.Instance.IndexState, { currentLevelName: currentLevelName })
    }
}

export function TestSite(props: React.Props<{}>): JSX.Element {

    RunOnce()

    return (
        <div className = "wrapper">
            <div className = "Content">
                <div id = "base" className = "content loggedin-false">
                    {RewardShop.getShop(
                        Main.Instance.IndexState.Category,
                        Main.Instance.IndexState.PointsXP
                    )}
                </div>
            </div>
        </div>
    )

// return <div>System maintenance!</div>
}


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Index.tsx